/* eslint-disable @typescript-eslint/no-explicit-any */
import { useMutation, useQuery } from "@tanstack/react-query"
import { apiClient } from "../client"
import { queryClient } from "../client/query-client"
import { queryKeysFactory } from "../client/query-key-factory"
import { SettingCreateBody, SettingDetailParam } from "../client/types"

const SETTING_QUERY_KEY = "setting" as const
const settingQueryKeys = {
  ...queryKeysFactory(SETTING_QUERY_KEY),
}
export const useSettingDetail = (params: SettingDetailParam) =>
  useQuery({
    queryKey: settingQueryKeys.list({
      vendorId: params.vendorId,
    }),
    queryFn: async ({ queryKey }) => {
      const { vendorId } = (queryKey?.[2].query || {}) as any

      if (!vendorId) return

      const res = await apiClient.vendor.setting.list(vendorId)
      return res?.data
    },
  })

export const useCreateSetting = () => {
  const createSetting = async ({
    vendorId,
    body,
  }: {
    vendorId: string
    body: SettingCreateBody
  }) => {
    return apiClient.vendor.setting.create(vendorId, body)
  }

  return useMutation({
    mutationFn: createSetting,
    onSuccess: (_, { vendorId }) => {
      queryClient.invalidateQueries({
        queryKey: settingQueryKeys.list({ vendorId }),
      })
    },
  })
}

export const useEditSetting = () => {
  const editSetting = async ({
    vendorId,
    body,
  }: {
    vendorId: string
    body: SettingCreateBody
  }) => {
    return apiClient.vendor.setting.update(vendorId, body)
  }

  return useMutation({
    mutationFn: editSetting,
    onSuccess: (_, { vendorId }) => {
      queryClient.invalidateQueries({
        queryKey: settingQueryKeys.list({ vendorId }),
      })
    },
  })
}
